import styled from 'styled-components';

export const BoldText = styled.span<{
  fontSize?: number;
  fontWeight?: number;
}>`
  font-weight: ${({ fontWeight = 600 }) => fontWeight};
  font-size: ${({ fontSize = 18 }) => fontSize}px;
  letter-spacing: 0.2px;
`;

export const SubText = styled.span`
  font-size: 14px;
  color: #979ea7;
  text-align: center;
  display: block;
`;
